import api from '../utils/api';
import { 
  Notification, 
  NotificationFilters,
  CreateNotificationRequest,
  CreateAnnouncementRequest 
} from '../types/notification';

export class NotificationApi {
  static async getNotifications(filters?: NotificationFilters): Promise<Notification[]> {
    const params = new URLSearchParams();
    if (filters?.read !== undefined) params.append('read', String(filters.read));
    if (filters?.type) params.append('type', filters.type);
    if (filters?.priority) params.append('priority', filters.priority);
    if (filters?.requiresAction !== undefined) params.append('requiresAction', String(filters.requiresAction));
    if (filters?.actionResolved !== undefined) params.append('actionResolved', String(filters.actionResolved));

    const response = await api.get<Notification[]>(
      `/api/notifications?${params.toString()}`
    );
    return response.data;
  }

  static async getUnreadCount(): Promise<number> {
    const response = await api.get<{ count: number }>(
      `/api/notifications/unread-count`
    );
    return response.data.count;
  }

  static async markAsRead(notificationId: string): Promise<void> {
    await api.patch(
      `/api/notifications/${notificationId}/read`,
      {}
    );
  }

  static async markAllAsRead(): Promise<void> {
    await api.patch(
      `/api/notifications/mark-all-read`,
      {}
    );
  }

  static async acknowledgeNotification(notificationId: string): Promise<{ acknowledgedAt?: string }> {
    const response = await api.patch<{ success: boolean; acknowledgedAt?: string }>(
      `/api/notifications/${notificationId}/acknowledge`,
      {}
    );
    return response.data;
  }

  static async dismissNotification(notificationId: string): Promise<void> {
    await api.patch(
      `/api/notifications/${notificationId}/dismiss`,
      {}
    );
  }

  static async deleteNotification(notificationId: string): Promise<void> {
    await api.delete(
      `/api/notifications/${notificationId}`
    );
  }

  // Admin only
  static async createNotification(data: CreateNotificationRequest): Promise<void> {
    await api.post(
      `/api/notifications/admin/create`,
      data
    );
  }

  // Admin only
  static async getAnnouncements(): Promise<any[]> {
    const response = await api.get(
      `/api/notifications/admin/announcements`
    );
    return response.data;
  }

  // Admin only
  static async getAnnouncementReadReceipts(announcementId: string): Promise<any[]> {
    const response = await api.get(
      `/api/notifications/admin/announcements/${announcementId}/receipts`
    );
    return response.data;
  }

  // Admin only
  static async createAnnouncement(data: CreateAnnouncementRequest): Promise<void> {
    await api.post(
      `/api/notifications/admin/announcement`,
      data
    );
  }
}

export default NotificationApi;
